import { useCallback, useEffect } from "react";

import FormField from "components/inputs/FormField/FormField";
import FormSelect from "components/inputs/FormSelect/FormSelect";

interface ClassificationFormInterface {
  formik: any;
  currentClassificationData?: any;
  classificationsData: any;
  currentType: any;
  setCurrentType: (option: any) => void;
  formFields: any;
}

const ClassificationForm = ({
  formik,
  currentClassificationData,
  classificationsData,
  currentType,
  setCurrentType,
  formFields
}: ClassificationFormInterface) => {
  const onSelectType = useCallback(
    (option) => {
      setCurrentType(option);
      formik.setValues({
        ...formik.values,
        classification: formik.initialValues.classification
      });
    },
    [formik, setCurrentType]
  );

  const onSelectField = useCallback(
    (fieldName: string) => (option) => {
      formik.setFieldValue(fieldName, option.value);
    },
    []
  );

  useEffect(() => {
    if (currentClassificationData) {
      const type = classificationsData.items.find(
        (item) => item.name === currentClassificationData.name
      );
      if (type) setCurrentType({ label: type?.name, value: type?.value });
    }
  }, [classificationsData, currentClassificationData, setCurrentType]);

  return (
    <form>
      <FormSelect
        label={classificationsData.name}
        value={currentType}
        options={classificationsData.items.map((item) => ({
          label: item.name,
          value: item.value
        }))}
        onSelectChange={onSelectType}
      />
      {formFields?.form?.map((field) => {
        if (field.type === "text" || field.type === "integer")
          return (
            <FormField
              name={`classification.${field.alias}`}
              label={field.name}
              key={`${currentType.value}-field-${field.alias}`}
            />
          );
        if (field.type === "list")
          return (
            <FormSelect
              label={field.name}
              name={`classification.${field.alias}`}
              value={{
                label:
                  field.items.find(
                    (item) =>
                      item.value === formik.values.classification[field.alias]
                  )?.name ?? undefined,
                value: formik.values.classification[field.alias] ?? undefined
              }}
              options={field.items.map((item) => ({
                label: item.name,
                value: item.value
              }))}
              onSelectChange={onSelectField(`classification.${field.alias}`)}
              key={`${currentType.value}-field-${field.alias}`}
              withFormik
            />
          );
        return <></>;
      })}
    </form>
  );
};

export default ClassificationForm;
